import { styled } from "styled-components";

export const SubscriptionDetailsPageContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f8fafc;
  font-family: "Lexend", "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;

  *,
  *::before,
  *::after {
    font-family: inherit;
    box-sizing: border-box;
  }

  .allContent {
    flex: 1;
    padding: 30px 0 60px 0;
  }

  .breadcrumb-nav {
    margin-bottom: 22px;
    font-size: 14px;
    color: #64748b;
    font-weight: 500;

    a {
      color: #024089;
      text-decoration: none;
      font-weight: 500;
      &:hover {
        text-decoration: underline;
      }
    }

    .btn-share-top {
      border: 1.5px solid #024089;
      background: #ffffff;
      color: #024089;
      font-weight: 600;
      font-size: 13px;
      padding: 6px 16px;
      border-radius: 8px;
      display: inline-flex;
      align-items: center;
      gap: 6px;
      transition: all 0.2s ease;
      cursor: pointer;

      &:hover {
        background: #f0f7ff;
        border-color: #024089;
        color: #024089;
      }
    }

    .btn-back {
      border: 1px solid #cbd5e1;
      background: #ffffff;
      color: #334155;
      font-weight: 500;
      font-size: 13px;
      padding: 6px 16px;
      border-radius: 8px;
      display: inline-flex;
      align-items: center;
      gap: 6px;
      transition: all 0.2s ease;
      cursor: pointer;

      &:hover {
        background: #f1f5f9;
        border-color: #94a3b8;
        color: #0f172a;
      }
    }
  }

  /* Left Side: Subscription Details Card */
  .subscription-left-card {
    background: #ffffff;
    border-radius: 14px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
    border: 1px solid #e2e8f0;
    overflow: hidden;
  }

  .plan-header-banner {
    display: flex;
    align-items: center;
    gap: 20px;

    .plan-image-box {
      width: 120px;
      height: 120px;
      min-width: 120px;
      background: #f8fafc;
      border: 1px solid #e2e8f0;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 10px;

      img {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
      }
    }

    .plan-header-info {
      flex: 1;

      .plan-title {
        font-size: 24px;
        font-weight: 700;
        color: #1e293b;
        margin-top: 8px;
        margin-bottom: 0;
        line-height: 1.3;
        letter-spacing: -0.01em;
      }
    }
  }

  .subscription-badge {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 4px 10px;
    border-radius: 6px;
    font-size: 11.5px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .badge-active {
    background-color: #dcfce7;
    color: #15803d;
    border: 1px solid #bbf7d0;
  }

  .badge-available {
    background-color: #e0f2fe;
    color: #0369a1;
    border: 1px solid #bae6fd;
  }

  .pricing-box {
    background-color: #f0f7ff;
    border: 1px solid #dbeafe;
    border-radius: 10px;
    padding: 14px 18px;
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
    gap: 10px;

    .current-price {
      font-size: 32px;
      font-weight: 800;
      color: #024089;
      letter-spacing: -0.02em;
    }

    .period {
      font-size: 14px;
      color: #64748b;
      font-weight: 500;
    }

    .original-price {
      font-size: 17px;
      color: #94a3b8;
      text-decoration: line-through;
      font-weight: 500;
    }

    .save-badge {
      background-color: #16a34a;
      color: #ffffff;
      font-size: 11.5px;
      font-weight: 700;
      padding: 3px 8px;
      border-radius: 6px;
      letter-spacing: 0.2px;
    }
  }

  .feature-pills-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
    gap: 12px;
    margin-bottom: 20px;
  }

  .feature-pill-item {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    padding: 12px 14px;
    display: flex;
    align-items: center;
    gap: 12px;
    transition: transform 0.2s, box-shadow 0.2s;

    &:hover {
      border-color: #cbd5e1;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    }

    .pill-icon {
      width: 40px;
      height: 40px;
      border-radius: 8px;
      background: #f0f7ff;
      color: #024089;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      flex-shrink: 0;
    }

    .pill-content {
      .pill-label {
        font-size: 11px;
        color: #64748b;
        text-transform: uppercase;
        font-weight: 600;
        letter-spacing: 0.5px;
      }
      .pill-value {
        font-size: 14px;
        font-weight: 700;
        color: #1e293b;
        margin-top: 2px;
      }
    }
  }

  .key-features-card {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    padding: 18px 20px;
    margin-bottom: 20px;

    .features-heading {
      font-size: 15.5px;
      font-weight: 700;
      color: #1e293b;
      margin-bottom: 12px;
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .features-body {
      font-size: 13.5px;
      line-height: 1.6;
      color: #475569;

      ul {
        padding-left: 18px;
        margin-bottom: 0;
      }

      li {
        margin-bottom: 7px;
      }
    }
  }

  .btn-share {
    border: 1.5px solid #024089;
    background: #ffffff;
    color: #024089;
    font-weight: 600;
    padding: 10px 20px;
    border-radius: 8px;
    font-size: 13.5px;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    transition: all 0.2s ease;
    cursor: pointer;

    &:hover {
      background: #f0f7ff;
      color: #024089;
    }
  }

  /* Right Side: Sticky Container & Registration Card */
  .sticky-right-card {
    position: sticky;
    top: 90px;
  }

  .registration-card {
    background: #ffffff;
    border: 1px solid #cbd5e1;
    border-radius: 14px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
    overflow: hidden;

    .reg-header {
      text-align: center;
      margin-bottom: 18px;

      .reg-logo {
        height: 38px;
        max-width: 170px;
        object-fit: contain;
        margin-bottom: 10px;
      }

      .reg-title {
        font-size: 21px;
        font-weight: 700;
        color: #024089;
        margin-bottom: 3px;
        letter-spacing: -0.01em;
      }

      .reg-subtitle {
        font-size: 12.5px;
        color: #64748b;
        margin-bottom: 0;
      }
    }

    .logged-in-box {
      background: #f8fafc;
      border: 1px solid #e2e8f0;
      border-radius: 10px;
      padding: 16px;
    }

    .form-group {
      margin-bottom: 14px;

      label {
        font-size: 12.5px;
        font-weight: 600;
        color: #334155;
        margin-bottom: 5px;
        display: block;
      }

      input,
      select {
        width: 100%;
        border-radius: 8px;
        border: 1px solid #cbd5e1;
        padding: 9px 13px;
        font-size: 13.5px;
        color: #1e293b;
        background: #ffffff;
        outline: none;
        transition: border-color 0.2s, box-shadow 0.2s;

        &:focus {
          border-color: #024089;
          box-shadow: 0 0 0 3px rgba(2, 64, 137, 0.12);
        }

        &::placeholder {
          color: #94a3b8;
        }

        &:disabled {
          background-color: #f1f5f9;
          color: #64748b;
          cursor: not-allowed;
        }
      }

      .field-error {
        color: #dc2626;
        font-size: 11.5px;
        font-weight: 500;
        margin-top: 4px;
      }
    }

    .btn-send-otp {
      background-color: #024089;
      color: #ffffff;
      font-weight: 600;
      font-size: 14px;
      padding: 11px 20px;
      border-radius: 8px;
      border: none;
      width: 100%;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      transition: background 0.2s;

      &:hover:not(:disabled) {
        background-color: #034fa8;
      }

      &:disabled {
        opacity: 0.65;
        cursor: not-allowed;
      }
    }

    .otp-section {
      background: #f8fafc;
      border: 1px dashed #cbd5e1;
      border-radius: 10px;
      padding: 16px 14px;
      text-align: center;

      .otp-title {
        font-size: 13px;
        font-weight: 600;
        color: #1e293b;
        margin-bottom: 12px;
      }

      .otp-input-control {
        width: 100%;
        max-width: 220px;
        margin: 0 auto 12px auto;
        letter-spacing: 8px;
        font-size: 20px;
        font-weight: 700;
        text-align: center;
        padding: 7px 10px;
        border-radius: 8px;
        border: 2px solid #024089;
        color: #024089;
        outline: none;
      }

      .otp-actions {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 8px;
        flex-wrap: wrap;

        .btn-verify {
          background-color: #024089;
          color: #ffffff;
          font-weight: 600;
          font-size: 13px;
          padding: 8px 16px;
          border-radius: 6px;
          border: none;
          cursor: pointer;
          flex: 1;

          &:hover:not(:disabled) {
            background-color: #034fa8;
          }

          &:disabled {
            opacity: 0.65;
            cursor: not-allowed;
          }
        }

        .btn-resend {
          background: none;
          border: none;
          color: #024089;
          font-size: 12.5px;
          font-weight: 600;
          cursor: pointer;
          text-decoration: underline;

          &:disabled {
            color: #94a3b8;
            cursor: not-allowed;
            text-decoration: none;
          }
        }

        .btn-edit {
          background: none;
          border: none;
          color: #64748b;
          font-size: 12px;
          cursor: pointer;

          &:hover {
            color: #1e293b;
            text-decoration: underline;
          }
        }
      }
    }

    .verified-banner {
      background: #ecfdf5;
      border: 1px solid #a7f3d0;
      border-radius: 8px;
      padding: 12px 14px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #065f46;

      .verified-info {
        display: flex;
        align-items: center;
        gap: 10px;

        .verified-icon {
          font-size: 22px;
          color: #10b981;
          flex-shrink: 0;
        }

        .verified-text {
          font-size: 13.5px;
          font-weight: 700;

          .verified-sub {
            font-size: 11.5px;
            font-weight: 400;
            color: #047857;
            margin-top: 1px;
          }
        }
      }

      .btn-reedit {
        background: none;
        border: none;
        color: #047857;
        font-size: 11.5px;
        font-weight: 600;
        cursor: pointer;
        text-decoration: underline;
      }
    }
  }

  .btn-subscribe {
    background-color: #024089;
    color: #ffffff;
    font-weight: 600;
    padding: 12px 24px;
    border-radius: 8px;
    font-size: 15px;
    border: 1px solid #024089;
    box-shadow: 0 4px 12px rgba(2, 64, 137, 0.25);
    transition: all 0.2s ease;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;

    &:hover:not(:disabled) {
      background-color: #034fa8;
      border-color: #034fa8;
      transform: translateY(-1px);
      box-shadow: 0 6px 16px rgba(2, 64, 137, 0.35);
    }

    &:disabled {
      background-color: #94a3b8;
      border-color: #94a3b8;
      box-shadow: none;
      cursor: not-allowed;
      transform: none;
      opacity: 0.8;
      color: #ffffff;
    }
  }

  .not-found-card {
    background: white;
    border-radius: 14px;
    padding: 50px 30px;
    text-align: center;
    border: 1px solid #e2e8f0;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);
  }

  @media (max-width: 991px) {
    .sticky-right-card {
      position: static;
      margin-top: 20px;
    }

    .plan-header-banner {
      flex-direction: column;
      align-items: flex-start;

      .plan-image-box {
        width: 100%;
        height: 160px;
      }
    }
  }
`;
